<template>
  <v-card>
    <v-tabs
      v-model="tab"
      background-color="blue-grey lighten-5"
    >
      <v-tab key="se_sky_race">Sky Race</v-tab>
      <v-tab key="se_sky_race_common">Sky Race Common</v-tab>
      <v-tab key="se_challenge">Challenge</v-tab>
      <v-tab key="se_lboard">Leaderboard</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" class="mt-4">
      <v-tab-item key="se_sky_race">
        <r-sky-sprint-config-page/>
      </v-tab-item>
      <v-tab-item key="se_sky_race_common">
        <r-sky-common-config-page/>
      </v-tab-item>
      <v-tab-item key="se_challenge">
        <r-challenge-config-page/>
      </v-tab-item>
      <v-tab-item key="se_lboard">
        <r-league-config-page/>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import RSkySprintConfigPage from "@/modules/redactor/views/server-events/skyrace/r-sky-sprint-config-page.vue";
import RSkyCommonConfigPage from "@/modules/redactor/views/server-events/skyrace/r-sky-common-config-page.vue";
import RChallengeConfigPage from "@/modules/redactor/views/server-events/challenge/r-challenge-config-page.vue";
import RLeagueConfigPage from "@/modules/redactor/views/server-events/leaderboard/r-league-config-page.vue";

export default {
  name: "r-ad-settings-page",
  components: {
    RSkySprintConfigPage,
    RSkyCommonConfigPage,
    RChallengeConfigPage,
    RLeagueConfigPage,
  },
  data: () => ({
    tab: null
  })
}

</script>